module.exports = __webpack_public_path__ + "static/media/ra.e4888310.jpg";